import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
// import { PageComponent } from './pages.component';
import { PageComponent } from './pages.component';
import { HomeComponent } from './SuperAdmin/home/home.component';
import { UnPaidOrderComponent } from './SuperAdmin/un-paid-order/un-paid-order.component';
import { OrderManagementComponent } from './SuperAdmin/order-management/order-management.component';
import { SalesAgentStatsComponent } from './SuperAdmin/sales-agent-stats/sales-agent-stats.component';
import { WriterPaymentComponent } from './SuperAdmin/writer-payment/writer-payment.component';
import { SignupsComponent } from './SuperAdmin/signups/signups.component';
import { UserPackagesComponent } from './SuperAdmin/user-packages/user-packages.component';
import { SalesHistoryComponent } from './SuperAdmin/sales-history/sales-history.component';

// Shared
import { ManageTeamComponent } from './Shared/manage-team/manage-team.component';
import { AddUserComponent } from './Shared/add-user/add-user.component';
import { ModifyOrderComponent } from './Shared/modify-order/modify-order.component';
import { OrderDetailsComponent } from './Shared/order-details/order-details.component';
import { SearchOrdersComponent } from './Shared/search-orders/search-orders.component';
import { ManageProfileComponent } from './Shared/manage-profile/manage-profile.component';

import { WritersDashboardComponent } from './Writers/writers-dashboard/writers-dashboard.component';
import { ManageCustomersComponent } from './SuperAdmin/manage-customers/manage-customers.component';

import { CustomerOrdersComponent } from './SuperAdmin/customer-orders/customer-orders.component';
import { OrderClassificationComponent } from './SuperAdmin/order-classification/order-classification.component';
import { AiSubscriptionLink } from './ai-subscription-link/ai-subscription-link.component';
import { AISubscriptionsComponent } from './SuperAdmin/ai-subscriptions/ai-subscriptions.component';
import { ClosedOrdersComponent } from './SuperAdmin/closed-orders/closed-orders.component';


const routes: Routes = [
  {
    path: '',
    component: PageComponent,
    children: [
      { path: '',                                     component: HomeComponent },
      { path: 'unpaid-orders',                        component: UnPaidOrderComponent },
      { path: 'signups',                              component: SignupsComponent },
      { path: 'user-packages',                        component: UserPackagesComponent },
      { path: 'order-management',                     component: OrderManagementComponent},
      { path: 'manage-team',                          component: ManageTeamComponent },
      { path: 'update-user/:userId',                  component: AddUserComponent },
      { path: 'add-user',                             component: AddUserComponent },
      { path: 'sales-agent-stats',                    component: SalesAgentStatsComponent },
      { path: 'modify-order/:slug',                   component: ModifyOrderComponent },
      { path: 'order-detail/:slug',                   component: OrderDetailsComponent },
      { path: 'search-orders',                        component: SearchOrdersComponent },
      { path: 'manage-profile',                       component: ManageProfileComponent },
      { path: 'writers-dashboard',                    component: WritersDashboardComponent },
      { path: 'manage-customers',                     component: ManageCustomersComponent },
      { path: 'customer-orders/:custId',              component: CustomerOrdersComponent },
      { path: 'writer-payment',                       component: WriterPaymentComponent },
      { path: 'all-leads',                            component: HomeComponent },
      { path: 'all-subscriptions',                            component: HomeComponent },
      { path: 'available-leads',                      component: HomeComponent },
      { path: 'ai-subscription-link',                 component: AiSubscriptionLink },
      { path: 'order-classification',                 component: OrderClassificationComponent },
      { path: 'sales-history',                        component: SalesHistoryComponent },
      { path: 'closed-orders',                        component: ClosedOrdersComponent },
      { path: 'ai-subscriptions',                        component: AISubscriptionsComponent },

      {
        path: 'support',
        loadChildren: () => import('./Support/support.module').then(m => m.SupportModule)
      },

      {
        path: 'sales',
        loadChildren: () => import('./Sales/sales.module').then(m => m.SalesModule)
      },

      {
        path: 'qa',
        loadChildren: () => import('./QA/qa.module').then(m => m.QAModule)
      },

      {
        path: 'writers',
        loadChildren: () => import('./Writers/writers.module').then(m => m.WritersModule)
      },

      {
        path: 'proofreaders',
        loadChildren: () => import('./Proofreaders/proofreaders.module').then(m => m.ProofreadersModule)
      },
      {
        path: 'feedback',
        loadChildren: () => import('./feed-back/feed-back.module').then(m => m.FeedBackModule)
      },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PagesRoutingModule {}
